module.exports = __webpack_public_path__ + "static/Burst_4s-9b26814ed86bacdae86d7e78f8135a58.jpg";